(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-lte-ui", [], factory);
	else if(typeof exports === 'object')
		exports["vue-lte-ui"] = factory();
	else
		root["vue-lte-ui"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(20)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _components = __webpack_require__(4);

var _directives = __webpack_require__(56);

var install = function install(Vue) {
  if (install.installed) return;

  // Register components
  _components.COMPONENTS.forEach(function (comp) {
    Vue.component(comp.name, comp);
  });

  // Register derectives
  _directives.DIRECTIVES.forEach(function (directive) {
    Vue.directive(directive.name, directive);
  });

  // Register services
  // SERVICES.forEach(service => {
  //   Vue[service.name] = Vue.prototype[service.name] = service;
  // });

  install.installed = true;
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
};

exports.default = {
  install: install,
  version: '0.3.1'
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPONENTS = undefined;

var _box = __webpack_require__(5);

var _box2 = _interopRequireDefault(_box);

var _infoBox = __webpack_require__(8);

var _infoBox2 = _interopRequireDefault(_infoBox);

var _smallBox = __webpack_require__(11);

var _smallBox2 = _interopRequireDefault(_smallBox);

var _alert = __webpack_require__(14);

var _alert2 = _interopRequireDefault(_alert);

var _progress = __webpack_require__(17);

var _progress2 = _interopRequireDefault(_progress);

var _pagination = __webpack_require__(23);

var _pagination2 = _interopRequireDefault(_pagination);

var _tabset = __webpack_require__(26);

var _tabset2 = _interopRequireDefault(_tabset);

var _tabItem = __webpack_require__(31);

var _tabItem2 = _interopRequireDefault(_tabItem);

var _modal = __webpack_require__(34);

var _modal2 = _interopRequireDefault(_modal);

var _timeline = __webpack_require__(37);

var _timeline2 = _interopRequireDefault(_timeline);

var _timelineItem = __webpack_require__(40);

var _timelineItem2 = _interopRequireDefault(_timelineItem);

var _rating = __webpack_require__(43);

var _rating2 = _interopRequireDefault(_rating);

var _tag = __webpack_require__(48);

var _tag2 = _interopRequireDefault(_tag);

var _tagInput = __webpack_require__(51);

var _tagInput2 = _interopRequireDefault(_tagInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENTS = exports.COMPONENTS = [_box2.default, _infoBox2.default, _smallBox2.default, _alert2.default, _progress2.default, _pagination2.default, _tabset2.default, _tabItem2.default, _modal2.default, _timeline2.default, _timelineItem2.default, _rating2.default, _tag2.default, _tagInput2.default];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(7),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-box',
  props: {
    type: { type: String, default: 'default' },
    header: { type: String, default: '' },
    icon: { type: String },
    collapsed: { type: Boolean, default: false },
    showHeaderBorder: { type: Boolean, default: true }
  },
  computed: {
    boxType: function boxType() {
      return 'box-' + this.type;
    }
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-box box",
    class: [_vm.boxType, {
      'collapsed-box': _vm.collapsed
    }]
  }, [_c('div', {
    staticClass: "box-header",
    class: {
      'with-border': _vm.showHeaderBorder
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._t("box-title", [(!!_vm.icon) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.header) + "\n      ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_vm._t("box-tools")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (!!_vm.$slots['box-footer']) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_vm._t("box-footer")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(10),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-info-box',
  props: {
    icon: { type: String },
    iconBg: { type: String },
    iconBgClass: { type: String },
    boxBg: { type: String },
    boxBgClass: { type: String }
  },
  computed: {
    boxStyle: function boxStyle() {
      return this._getBgStyle(this.boxBg);
    },
    iconStyle: function iconStyle() {
      return this._getBgStyle(this.iconBg);
    }
  },
  methods: {
    _getBgStyle: function _getBgStyle(color) {
      var style = {};
      color && (style['background-color'] = color);
      return style;
    }
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-info-box info-box",
    class: _vm.boxBgClass,
    style: (_vm.boxStyle)
  }, [_c('span', {
    staticClass: "info-box-icon",
    class: _vm.iconBgClass,
    style: (_vm.iconStyle)
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(13),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-small-box',
  props: {
    icon: { type: String },
    boxBg: { type: String },
    boxBgClass: { type: String }
  },
  computed: {
    boxStyle: function boxStyle() {
      return this._getBgStyle(this.boxBg);
    }
  },
  methods: {
    footerClick: function footerClick(evt) {
      this.$emit('footer-click', evt);
    },
    _getBgStyle: function _getBgStyle(color) {
      var style = {};
      color && (style['background-color'] = color);
      return style;
    }
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-small-box small-box",
    class: _vm.boxBgClass,
    style: (_vm.boxStyle)
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), (!!_vm.$slots['box-footer']) ? _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.footerClick
    }
  }, [_vm._t("box-footer")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(16),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'lte-alert',
  props: {
    type: { type: String, default: 'info' },
    calloutStyle: { type: Boolean, default: false },
    closable: { type: Boolean, default: false }
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('close', true);
  },

  computed: {
    alertClass: function alertClass() {
      var prefix = this.calloutStyle ? 'callout' : 'alert';
      return [prefix, prefix + '-' + this.type];
    }
  },
  methods: {
    closeBtnClick: function closeBtnClick(evt) {
      this.$el.remove(); // 使用DOM方法，移除自身
      this.$destroy(true); // 释放组件
    }
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-alert",
    class: _vm.alertClass
  }, [(_vm.closable) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeBtnClick
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(22),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(19);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7dc6bbf8", content, true);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".lte-progress .progress-text{position:absolute;width:100%;text-align:center}", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-progress',
  props: {
    type: { type: String, default: 'info' },
    striped: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    value: { type: Number },
    text: { type: String, default: '' },
    max: { type: Number, default: 100 },
    size: { type: String, default: '' },
    active: { type: Boolean, default: false }
  },
  computed: {
    progressBarStyle: function progressBarStyle() {
      var percent = Math.min((this.value || 0) / this.max * 100, 100).toFixed(2);
      return _defineProperty({}, this.vertical ? 'height' : 'width', percent + '%');
    }
  },
  methods: {
    closeBtnClick: function closeBtnClick(evt) {
      this.$el.remove(); // 使用DOM方法，移除自身
      this.$destroy(true); // 释放组件
    }
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-progress progress",
    class: ['progress-' + _vm.size, {
      active: _vm.active,
      vertical: _vm.vertical
    }]
  }, [_c('div', {
    staticClass: "progress-bar",
    class: ['progress-bar-' + _vm.type, {
      'progress-bar-striped': _vm.striped
    }],
    style: (_vm.progressBarStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(25),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-pagination',
  props: {
    size: { type: String, default: '' },
    firstText: { type: String, default: 'First' },
    lastText: { type: String, default: 'Last' },
    prevText: { type: String, default: 'Prev' },
    nextText: { type: String, default: 'Next' },
    maxItemCount: { type: Number, default: 5 },
    pageSize: { type: Number, default: 20 },
    // pageItems: { type: Array, default: () => [] },
    totalCount: { type: Number, default: 0 },
    value: { type: Number, default: 1 }
  },
  data: function data() {
    return {
      pageItems: []
    };
  },
  created: function created() {
    this._setPageItems();
  },

  computed: {
    pageCount: function pageCount() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
    }
  },
  watch: {
    pageCount: function pageCount(newVal) {
      if (this.value > newVal) {
        this._setPageIndex(newVal);
      }
      this._setPageItems();
    },
    value: function value() {
      this._setPageItems();
    }
  },
  methods: {
    _setPageItems: function _setPageItems() {
      var pages = [];
      var totalPageItemsCount = Math.ceil(this.pageCount / this.maxItemCount); // 总得pageItems个数
      var inPageIndex = Math.max(1, Math.ceil(this.value / this.maxItemCount)); // 页码必须大于等于1
      var startIdx = this.maxItemCount * (inPageIndex - 1); // 计算起点索引
      var endIndex = Math.min(startIdx + this.maxItemCount, this.pageCount);
      for (var i = startIdx + 1; i <= endIndex; i++) {
        pages.push({ page: i, text: String(i) });
      }
      if (inPageIndex < totalPageItemsCount) {
        // 不是最后一个pageItems
        pages.push({ text: '...', page: endIndex + 1 });
      }
      if (inPageIndex > 1) {
        // 不是第一页
        pages.unshift({ text: '...', page: startIdx - 1 });
      }
      this.pageItems = pages;
    },
    setPageIndex: function setPageIndex(p, disabled) {
      if (disabled) {
        return;
      }
      if (p > 0 && p <= this.pageCount) {
        this._setPageIndex(p);
      }
    },
    _setPageIndex: function _setPageIndex(val) {
      this.$emit('input', val);
      this.$emit('page-changed', val);
    }
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lte-pagination pagination no-margin",
    class: ['pagination-' + _vm.size]
  }, [(!!_vm.firstText) ? _c('li', {
    class: {
      disabled: _vm.value <= 1
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(1, _vm.value <= 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.firstText))])]) : _vm._e(), _vm._v(" "), (!!_vm.prevText) ? _c('li', {
    class: {
      disabled: _vm.value <= 1
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(_vm.value - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.prevText))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageItems), function(p) {
    return _c('li', {
      class: {
        active: _vm.value === p.page
      },
      on: {
        "click": function($event) {
          _vm.setPageIndex(p.page)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(p.text))])])
  }), _vm._v(" "), (!!_vm.nextText) ? _c('li', {
    class: {
      disabled: _vm.value >= _vm.pageCount
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(_vm.value + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.nextText))])]) : _vm._e(), _vm._v(" "), (!!_vm.lastText) ? _c('li', {
    class: {
      disabled: _vm.value >= _vm.pageCount
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(_vm.pageCount, _vm.value >= _vm.pageCount)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.lastText))])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(30),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(28);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7529610c", content, true);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".lte-tabset{margin-bottom:0}.lte-tabset .fa.fa-close{margin-left:5px;width:16px;text-align:center;cursor:pointer}.lte-tabset .fa.fa-close:hover{color:#dd4b39;border:1px solid #dd4b39;border-radius:50%}", ""]);

// exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-tabset',
  props: {
    direction: { type: String, default: 'left' },
    value: null
  },
  data: function data() {
    return {
      tabItems: [],
      innerValue: 0
    };
  },
  mounted: function mounted() {
    this.innerValue = this.value;
  },

  watch: {
    value: function value() {
      this.innerValue = this.value;
    }
  },
  methods: {
    changeTab: function changeTab(tabItem) {
      this._updateValue(tabItem.name);
      this.$emit('tab-click', tabItem);
    },
    removeTabItem: function removeTabItem(tabItem) {
      var waitForRemoveItem = this._getTabItems().find(function (x) {
        return x.name === tabItem.name;
      });
      if (waitForRemoveItem) {
        waitForRemoveItem.removeSelf();
        this.$emit('tab-remove', tabItem);
      }
    },
    updateTabs: function updateTabs() {
      var _this = this;

      var matchValue = false;
      var tabs = [];
      this._getTabItems().forEach(function (item, i) {
        var tabItem = {
          header: item.header || '',
          icon: item.icon || '',
          name: item.name || i,
          closable: item.closable,
          disabled: item.disabled
        };
        tabs.push(tabItem);
        if (tabItem.name === _this.value) {
          matchValue = true;
        }
      });
      if (!matchValue && tabs.length > 0) {
        this._updateValue(tabs[0].name);
      }
      this.tabItems = tabs;
    },
    _updateValue: function _updateValue(value) {
      this.innerValue = value;
      this.$emit('input', value);
    },
    _getTabItems: function _getTabItems() {
      return this.$children.filter(function (x) {
        return x.$options.name === 'lte-tab-item';
      });
    }
  }
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-tabset nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    class: {
      'pull-right': _vm.direction === 'right'
    }
  }, [_vm._l((_vm.tabItems), function(item) {
    return _c('li', {
      class: {
        active: _vm.innerValue === item.name
      },
      on: {
        "click": function($event) {
          _vm.changeTab(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("  " + _vm._s(item.header) + " "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.closable),
        expression: "item.closable"
      }],
      staticClass: "fa fa-close",
      on: {
        "click": function($event) {
          _vm.removeTabItem(item)
        }
      }
    })])])
  }), _vm._v(" "), _vm._t("tabset-tools")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(33),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  name: 'lte-tab-item',
  props: {
    name: { type: [String, Number] },
    header: { type: String, default: '' },
    icon: { type: String, default: '' },
    closable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this._updateParent();
  },

  computed: {
    active: function active() {
      return this.name === this.$parent.innerValue;
    },
    propsChange: function propsChange() {
      return 'name = ' + this.name + ' | header = ' + this.header + ' | icon = ' + this.icon + ' | closable = ' + this.closable + ' | disabled = ' + this.disabled;
    }
  },
  watch: {
    propsChange: function propsChange() {
      this._updateParent();
    }
  },
  methods: {
    removeSelf: function removeSelf() {
      this.$el.remove();
      this.$destroy(true);
      this._updateParent();
    },
    _updateParent: function _updateParent() {
      this.$parent.updateTabs();
    }
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-tab-item tab-pane",
    class: {
      active: _vm.active
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(36),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-modal',
  props: {
    type: { type: String, default: '' },
    header: { type: String, default: '' },
    okText: { type: String, default: 'Save changes' },
    cancelText: { type: String, default: 'Cancel' },
    closable: { type: Boolean, default: true },
    value: { type: Boolean, default: false },
    size: { type: String, default: '' },
    width: { type: [Number, String] }
  },
  data: function data() {
    return {
      innerValue: false
    };
  },
  mounted: function mounted() {
    this.innerValue = this.value;
  },

  computed: {
    modalSizeClass: function modalSizeClass() {
      return this.size ? ['modal-' + this.size] : [];
    },
    modalStyle: function modalStyle() {
      return this.width ? { width: this.width + 'px' } : null;
    }
  },
  watch: {
    value: function value(newVal) {
      this.innerValue = newVal;
    }
  },
  methods: {
    cancelClick: function cancelClick(evt) {
      this.innerValue = false;
      this.$emit('input', false);
      this.$emit('cancel', evt);
    },
    okClick: function okClick(evt) {
      this.$emit('ok', evt);
    }
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade in",
    class: ['modal-' + _vm.type],
    staticStyle: {
      "padding-right": "17px",
      "display": "none"
    },
    style: ({
      display: _vm.innerValue ? 'block' : 'none'
    })
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.modalSizeClass,
    style: (_vm.modalStyle)
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.closable) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("modal-header", [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.header))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [_c('button', {
    staticClass: "btn pull-left",
    class: [!_vm.type ? 'btn-default' : 'btn-outline'],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: [!_vm.type ? 'btn-primary' : 'btn-outline'],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.okClick
    }
  }, [_vm._v(_vm._s(_vm.okText))])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(39),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  name: 'lte-timeline',
  props: {}
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lte-timeline timeline"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(42),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-timeline-item',
  props: {
    isLabel: { type: Boolean, default: false },
    labelBgClass: { type: String },
    icon: { type: String, default: '' },
    iconBgClass: { type: String, default: '' },
    end: { type: Boolean, default: false }
  }
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'time-label': _vm.isLabel
    }
  }, [(_vm.isLabel) ? [_c('span', {
    class: _vm.labelBgClass
  }, [_vm._t("default")], 2)] : _vm._e(), _vm._v(" "), (!_vm.isLabel) ? [_c('i', {
    class: [_vm.icon, _vm.iconBgClass]
  }), _vm._v(" "), (!_vm.end) ? _c('div', {
    staticClass: "timeline-item"
  }, [_vm._t("default")], 2) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(45);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6eb9215a", content, true);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".lte-rating i{cursor:pointer}.lte-rating i.fa-star{color:#f5a623}.lte-rating.readonly i{cursor:default}", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-rating',
  props: {
    max: { type: Number, default: 5 },
    allowHalf: { type: Boolean, default: false },
    value: { type: Number, default: 1 },
    readonly: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      innerValue: -1,
      tempIdx: -1
    };
  },
  created: function created() {
    this.innerValue = this.value;
  },

  watch: {
    value: function value() {
      this.innerValue = this.value;
    },
    max: function max(newVal) {
      this._setStarArr(newVal);
    }
  },
  methods: {
    onMouseMove: function onMouseMove(idx) {
      if (this.readonly) {
        return;
      }
      this.tempIdx = idx;
    },
    onMouseLeave: function onMouseLeave() {
      this.tempIdx = -1;
    },
    starClick: function starClick(idx) {
      if (this.readonly) {
        return;
      }
      this._setValue(idx);
    },
    _setValue: function _setValue(v) {
      this.$emit('input', v);
      this.$emit('change', v);
    }
  }
};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "lte-rating",
    class: {
      readonly: _vm.readonly
    },
    on: {
      "mouseleave": _vm.onMouseLeave
    }
  }, _vm._l((_vm.max), function(idx) {
    return _c('i', {
      staticClass: "fa",
      class: {
        'fa-star': idx <= _vm.innerValue || idx <= _vm.tempIdx, 'fa-star-o': idx > _vm.innerValue
      },
      on: {
        "click": function($event) {
          _vm.starClick(idx)
        },
        "mousemove": function($event) {
          _vm.onMouseMove(idx)
        }
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(50),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  name: 'lte-tag',
  props: {
    type: { type: String, default: 'primary' },
    badge: { type: Boolean, default: false },
    bgColor: { type: String, default: '' },
    bgClass: { type: String, default: '' }
  },
  computed: {
    classArr: function classArr() {
      var clsArr = [];
      if (this.badge) {
        clsArr.push('badge');
        this.bgClass && clsArr.push(this.bgClass);
      } else {
        clsArr.push('label');
        this.type && clsArr.push('label-' + this.type);
      }
      return clsArr;
    }
  }
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "lte-tag",
    class: _vm.classArr,
    style: ({
      'background-color': _vm.bgColor + '!important'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(53);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8a1751d0", content, true);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".lte-tag-input{border:1px solid #d2d6de;line-height:34px;background:#fff;padding:0 5px}.lte-tag-input.focus{border-color:#3c8dbc}.lte-tag-input .form-control{border:none;width:auto;display:inline;padding-left:0}.lte-tag-input .label{float:left;margin-top:5px;margin-right:5px;height:24px;line-height:24px;padding:0 .6em}.lte-tag-input .label .fa.fa-remove{float:right;cursor:pointer;margin:0 -5px 0 5px}.lte-tag-input .label .fa.fa-remove:hover{color:orange}", ""]);

// exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'lte-tag-input',
  data: function data() {
    return {
      focused: false,
      tags: [],
      inputTag: ''
    };
  },

  props: {
    allowDuplicate: { type: Boolean, default: false },
    value: null
  },
  mounted: function mounted() {
    this._setValue();
  },

  watch: {
    value: function value() {
      this._setValue();
    }
  },
  methods: {
    removeTag: function removeTag(idx) {
      this.tags.splice(idx, 1);
    },
    addTag: function addTag() {
      if (this.inputTag) {
        // 如果不允许重复，但重复，禁止添加
        if (!this.allowDuplicate && this.tags.indexOf(this.inputTag) >= 0) {
          return;
        }
        this.tags.push(this.inputTag);
        this._emitValue();
      }
      this.inputTag = '';
    },
    _setValue: function _setValue() {
      this.tags = (this.value || []).slice(0);
    },
    _emitValue: function _emitValue() {
      this.$emit('input', this.tags);
    }
  }
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-tag-input",
    class: {
      focus: _vm.focused
    },
    on: {
      "click": function($event) {
        _vm.$refs.input.focus()
      }
    }
  }, [_vm._l((_vm.tags), function(t, idx) {
    return _c('label', {
      key: idx,
      staticClass: "label label-primary"
    }, [_vm._v("\n    " + _vm._s(t) + "\n    "), _c('i', {
      staticClass: "fa fa-remove",
      on: {
        "click": function($event) {
          _vm.removeTag(idx)
        }
      }
    })])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputTag),
      expression: "inputTag"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inputTag)
    },
    on: {
      "blur": function($event) {
        _vm.focused = false
      },
      "focus": function($event) {
        _vm.focused = true
      },
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTag($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputTag = $event.target.value
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIRECTIVES = undefined;

var _tooltip = __webpack_require__(57);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIRECTIVES = exports.DIRECTIVES = [_tooltip2.default];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'lte-tooltip',
  bind: function bind(el, binding) {
    el.$$tooltip = binding.value;
    var $el = $(el);
    $el.tooltip({
      title: function title() {
        return el.$$tooltip;
      }
    });
  },
  update: function update(el, binding) {
    el.$$tooltip = binding.value;
  },
  unbind: function unbind(el, binding) {
    var $el = $(el);
    $el.off('mouseenter');
  }
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-lte-ui.js